/* global $ */
import React, { useState, useEffect, useRef } from 'react';
import axiosInstance from "../axiosInstance";
import { Link, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import Footer from '../components/Footer';

function Companysettings() {
    const formRef = useRef(null);
    const [newRecord, setNewRecord] = useState({
        id: null,
        companyName: "",
        addressLine1: "",
        addressLine2: "",
        city: "",
        state: "",
        country: "",
        zipCode: "",
        phoneNumber: "",
        email: "",
        gstinNo: ""
    });

    // Handle Form Input Change
    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewRecord(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const fetchCompanyData = async () => {
        try {
            const response = await axiosInstance.get("/company/");
            // If API returns an array, use first item
            if (Array.isArray(response.data) && response.data.length > 0) {
                setNewRecord(response.data[0]); // Assuming single company record
            } else {
                setNewRecord(response.data); // If it's an object
            }
        } catch (error) {
            console.error("Error fetching company data:", error);
        }
    };

    useEffect(() => {
        fetchCompanyData();
    }, []);

    // Handle Form Submission (Create)
    const handleSubmit = async (e) => {
        e.preventDefault();
        console.log("enter")
        console.log("Data:", newRecord)
        if (!formRef.current.checkValidity()) {
            console.log("isvalidating")
            formRef.current.classList.add("was-validated");
            return;
        }

        try {
            const response = await axiosInstance.put(`/company/${newRecord.id}`, newRecord);
            if (response) {
                Swal.fire("Updated!", "The Product record has been updated.", "success");
            }
            fetchCompanyData(); // Re-fetch updated info
        } catch (error) {
            console.error("Error adding product:", error);
            Swal.fire("Error", "Failed to create product", "error");
        }
    };

    return (
        <div class="page-wrapper">
            <div class="content container-fluid">
                {/* Page Header */}

                {/* /Page Header */}

                <div class="row">
                    <div class="col-xl-3 col-md-4">

                        <div class="card">
                            <div class="card-body">
                                <div class="page-header">
                                    <div class="content-page-header">
                                        <h5>Settings</h5>
                                    </div>
                                </div>
                                {/* Settings Menu */}
                                <div class="widget settings-menu mb-0">
                                    <ul>
                                        <li class="nav-item">
                                            <a href="/settings" class="nav-link">
                                                <i class="fe fe-user"></i> <span>Account Settings</span>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a href="/company-settings" class="nav-link active">
                                                <i class="fe fe-settings"></i> <span>Company Settings</span>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a href="invoice-settings.html" class="nav-link">
                                                <i class="fe fe-file"></i> <span>Invoice Settings</span>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a href="template-invoice.html" class="nav-link">
                                                <i class="fe fe-layers"></i> <span>Invoice Templates</span>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a href="payment-settings.html" class="nav-link">
                                                <i class="fe fe-credit-card"></i> <span>Payment Methods</span>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a href="bank-account.html" class="nav-link">
                                                <i class="fe fe-aperture"></i> <span>Bank Settings</span>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a href="tax-rats.html" class="nav-link">
                                                <i class="fe fe-file-text"></i> <span>Tax Rates</span>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a href="plan-billing.html" class="nav-link">
                                                <i class="fe fe-credit-card"></i> <span>Plan & Billing</span>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a href="two-factor.html" class="nav-link">
                                                <i class="fe fe-aperture"></i> <span>Two Factor</span>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a href="custom-filed.html" class="nav-link">
                                                <i class="fe fe-file-text"></i> <span>Custom Fields</span>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a href="email-settings.html" class="nav-link">
                                                <i class="fe fe-mail"></i> <span>Email Settings</span>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a href="preferences.html" class="nav-link">
                                                <i class="fe fe-settings"></i> <span>Preference Settings</span>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a href="email-template.html" class="nav-link">
                                                <i class="fe fe-airplay"></i> <span>Email Templates</span>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a href="seo-settings.html" class="nav-link">
                                                <i class="fe fe-send"></i> <span>SEO Settings</span>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a href="saas-settings.html" class="nav-link">
                                                <i class="fe fe-target"></i> <span>SaaS Settings</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                {/* /Settings Menu */}
                            </div>
                        </div>
                    </div>
                    <div class="col-xl-9 col-md-8">
                        <div class="card company-settings-new">
                            <div class="card-body w-100">
                                <div class="content-page-header">
                                    <h5>Company Settings</h5>
                                </div>

                                <form ref={formRef} onSubmit={handleSubmit}>
                                    <div class="row">
                                        <div class="col-lg-6 col-12">
                                            <div class="input-block mb-3">
                                                <label>Company Name</label>
                                                <input type="text" name="companyName" value={newRecord.companyName || ""} onChange={handleChange} class="form-control" placeholder="Enter Company Name" />
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-12">
                                            <div class="input-block mb-3">
                                                <label>Address Line 1</label>
                                                <input type="text" name="addressLine1" value={newRecord.addressLine1 || ""} onChange={handleChange} class="form-control" placeholder="Enter Address Line 1" />
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-12">
                                            <div class="input-block mb-3">
                                                <label>Address Line 2</label>
                                                <input type="text" name="addressLine2" value={newRecord.addressLine2 || ""} onChange={handleChange} class="form-control" placeholder="Enter Address Line 2" />
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-12">
                                            <div class="input-block mb-3">
                                                <label>Country</label>
                                                <input type="text" name="country" value={newRecord.country || ""} onChange={handleChange} class="form-control" placeholder="Enter Country" />
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-12">
                                            <div class="input-block mb-3">
                                                <label>State</label>
                                                <input type="text" name="state" value={newRecord.state || ""} onChange={handleChange} class="form-control" placeholder="Enter State" />
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-12">
                                            <div class="input-block mb-3">
                                                <label>City</label>
                                                <input type="text" name="city" value={newRecord.city || ""} onChange={handleChange} class="form-control" placeholder="Enter City" />
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-12">
                                            <div class="input-block mb-3">
                                                <label>Pincode</label>
                                                <input type="text" name="zipCode" value={newRecord.zipCode || ""} onChange={handleChange} class="form-control" placeholder="Enter Pincode" />
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-12">
                                            <div class="input-block mb-3">
                                                <label>Phone Number</label>
                                                <input type="text" name="phoneNumber" value={newRecord.phoneNumber || ""} onChange={handleChange} class="form-control" placeholder="Enter Phone Number" />
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-12">
                                            <div class="input-block mb-3">
                                                <label>Company Email</label>
                                                <input type="text" name="email" value={newRecord.email || ""} onChange={handleChange} class="form-control" placeholder="Enter Company Email" />
                                            </div>
                                        </div>
                                        <div class="col-lg-6 col-12">
                                            <div class="input-block mb-3">
                                                <label>GST Number</label>
                                                <input type="text" name="gstinNo" value={newRecord.gstinNo || ""} onChange={handleChange} class="form-control" placeholder="Enter GST Number" />
                                            </div>
                                        </div>
                                        <div class="col-lg-12">
                                            <div class="btn-path text-end">
                                                <button href="#" class="btn btn-cancel bg-primary-light me-3">Cancel</button>
                                                <button type="submit" class="btn btn-primary">Save Changes</button>
                                            </div>
                                        </div>
                                    </div>
                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Companysettings